import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    AlertActionsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getHitArea
} from "../../../../helpers/theme/control";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row"
    },
    wrapped: {
        flexWrap: "wrap"
    },
    inline: {
        flexShrink: 0
    }
});

export const useStyles = ({
    controlHeights,
    touchTargets,
    pointerType,
    typography,
    isCompact,
    spaces
}: AlertActionsDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: controlHeights.small,
        touchTargets,
        pointerType
    });

    const reservedHeight = hitArea.minHeight - controlHeights.small;

    const gap = pointerType === "coarse" ? touchTargets.coarse - controlHeights.small : spaces.spacingSm;

    const styles = {
        container: {
            marginVertical: ((isCompact ? typography.titleSmallSize.lineHeight : controlHeights.small) - hitArea.minHeight) / 2,
            rowGap: gap - reservedHeight,
            columnGap: gap
        } as Mutable<ViewStyle>
    };

    if(!isCompact) {
        styles.container.paddingTop = spaces.spacingSm;
    }

    return styles;
};
export default stylesheet;
